import { Caption, Checkbox, CheckboxState } from 'Components/designSystem';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { OfferItemsTranslationSection } from './types';

interface ScheduleProps {
    onSelectAllClick: () => void;
    itemsSelected: number;
    itemsTotal: number;
    translationSection: OfferItemsTranslationSection;
}

export default function ShiftsListHead({ onSelectAllClick, itemsTotal, itemsSelected, translationSection }: ScheduleProps) {
    const { t } = useTranslation('candidateOffers');

    return (
        <Root>
            <Checkbox label={ t('selectAll') }
                onChange={ onSelectAllClick }
                state={ itemsTotal === itemsSelected 
                    ? CheckboxState.Checked 
                    : (itemsSelected ? CheckboxState.PartlyChecked : CheckboxState.NotChecked) }
            />
            <Caption strong
                color="primary"
            >
                { t(`${ translationSection }.selection`, { count: itemsSelected }) }
            </Caption>
        </Root>
    );
}

const Root = styled.div`
    padding: 12px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
